import React from "react";
import MainContainer from "./containers/MainContainer/MainContainer";
import "./styles/index.less";

function RolesModule() {
  return <MainContainer />;
}

export default RolesModule;
